<template>
  <div v-if="isSelected">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: {
    isSelected: {
      type: Boolean
    }
  }
}
</script>
